import classNames from 'classnames';

import style from './Text.module.css';

import {
  getFontClass,
  getFontWeightClass,
  getTextSizeClass,
  getColorClass,
  getAttentionColorName,
  getTrackingClass,
  FontProps,
  ColorProps,
  WeightProps,
  TextSizeProps,
  TextTrackingProps,
  TextLeadingProps,
  getLeadingClass
} from '../../../constants/typography';

interface Props {
  as?: 'p' | 'span' | 'div';
  font?: FontProps;
  size?: TextSizeProps;
  weight?: WeightProps;
  italic?: boolean;
  color?: ColorProps | 'inherit';
  tracking?: TextTrackingProps;
  leading?: TextLeadingProps | null;
  className?: string;
  onClick?: () => null;
  children?: string | JSX.Element | JSX.Element[];
}

function Text({
  as: Tag = 'p',
  font = 'camphor',
  size = 'sm',
  weight = 400,
  color = 'blue',
  italic = false,
  tracking = 'normal',
  leading = null,
  className,
  onClick,
  children
}: Props) {
  return (
    <Tag
      className={classNames([
        'flex flex-col gap-5',
        className,
        style.content,
        getFontClass(font),
        getTextSizeClass(size),
        getFontWeightClass(weight),
        color !== 'inherit' && getColorClass(color),
        { italic },
        getTrackingClass(tracking),
        leading && getLeadingClass(leading)
      ])}
      onClick={onClick}
      style={
        {
          '--attention-color': `var(--color-${getAttentionColorName(
            color
          )})`
        } as React.CSSProperties
      }
    >
      {children}
    </Tag>
  );
}

export default Text;
